import React from 'react';
import Css from './ProgressBox.scss';

const progressBox = props => {
  return (
    <div className={Css.loader + ' d-flex align-items-center'}>
      <div className={Css.content}>
        {props.icon}
        {props.text}
      </div>
    </div>
  );
};

export default progressBox;



// WEBPACK FOOTER //
// ./src/components/ProgressBox/ProgressBox.jsx